module.exports = "/_next/static/images/powered-by-google-on-white-hdpi-60e8a8323a1f5c9dc59c6783d5974123.png";